import { Component, Input, OnInit } from '@angular/core';
import {
	FinancialInstitutionChargeTypes,
	FinancialInstitutionChargeTypesList,
} from '@core/util/lenderForms';
import {
	ChargeTypes,
	DocumentTypes,
	FinancialInstitutionsId,
	MatterMortgage,
} from '@models/mortgage';
import { MatterMortgageDispatch } from '@state/matter/matter_mortgages';
import { RadioGroupItem } from 'src/app/shared/atomic/atoms/radio-group/radio-group.component';

@Component({
	selector: 'app-charge-type-select',
	templateUrl: './charge-type-select.component.html',
	standalone: false,
})
export class ChargeTypeSelectComponent implements OnInit {
	@Input() set mortgage(mortgage: MatterMortgage) {
		this._mortgage = mortgage;
		this.selectedFinancialInstitution = mortgage?.forms?.financialInstitutionId;
		this.selectedChargeTypeName = mortgage?.forms?.chargeType;
		this.selectedDocumentTypeName = mortgage?.forms?.documentType;
	}

	@Input() showLabels = true;

	public _mortgage: MatterMortgage;

	public chargeTypesList: RadioGroupItem<ChargeTypes>[] = [];
	public documentTypesList: RadioGroupItem<DocumentTypes>[] = [];
	public financialInstitutionChargeTypesList =
		FinancialInstitutionChargeTypesList;
	public selectedFinancialInstitutionChargeType: FinancialInstitutionChargeTypes;

	public financialInstitutions = this.financialInstitutionChargeTypesList.map(
		(inst) => ({
			name: inst.institutionName,
			id: inst.institutionId,
		}),
	);

	public _selectedFinancialInstitution;
	public selectedFinancialInstitutionName;

	public selectedDocumentTypeName: DocumentTypes;
	public selectedChargeTypeName;

	public set selectedFinancialInstitution(
		selectedFinancialInstitution: FinancialInstitutionsId,
	) {
		if (selectedFinancialInstitution) {
			this._selectedFinancialInstitution = selectedFinancialInstitution;

			const financialInstitution = FinancialInstitutionChargeTypesList.find(
				(inst) => inst.institutionId === selectedFinancialInstitution,
			);

			if (financialInstitution?.documentTypes) {
				this.documentTypesList = financialInstitution?.documentTypes;
			} else {
				this.documentTypesList = [];
				this.selectedDocumentTypeName = null;
			}
			if (financialInstitution?.chargeTypes) {
				this.chargeTypesList =
					financialInstitution?.chargeTypes?.default ??
					financialInstitution?.chargeTypes?.[this.selectedDocumentTypeName];
			} else {
				this.chargeTypesList = null;
			}
		}
	}

	public get selectedFinancialInstitution() {
		return this._selectedFinancialInstitution;
	}

	constructor(private mortgageDispatch: MatterMortgageDispatch) {}

	ngOnInit(): void {}

	onSelectChargeType(chargeType) {
		this.selectedChargeTypeName = chargeType;
		this.mortgageDispatch.SetMortgageFormsChargeType(
			this._mortgage.id,
			chargeType,
		);
	}

	onSelectDocumentType(documentType) {
		this.selectedDocumentTypeName = documentType;
		this.mortgageDispatch.SetMortgageFormsDocumentType(
			this._mortgage.id,
			documentType,
		);
	}
}
